import { Typography, Skeleton } from '@client/toolkit';
import { MetricCard } from './metric-card';
import { toNumberString } from '@client/toolkit';

export function NetYieldCard({
  title,
  value,
  loading,
  showDirection = false,
}: {
  title: string;
  value: number;
  loading: boolean;
  showDirection?: boolean;
}) {
  return (
    <MetricCard title={title}>
      <span className="flex items-center gap-2">
        {loading ? (
          <Skeleton className="h-[48px] w-[82px]" />
        ) : (
          <Typography
            variantFontSize="h2"
            className={showDirection ? (value > 0 ? 'text-green-500' : 'text-red-500') : ''}
          >
            {showDirection && value > 0 ? '+' : ''}
            {toNumberString(value)}%
          </Typography>
        )}
      </span>
    </MetricCard>
  );
}
